<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>OEA Contratación</f7-nav-title>
    </f7-navbar>
    <div class="sello-datos-bar"><sello-datos estado="vivo" /></div>
    <f7-block-header style="font-size: 13px; color: #666; margin-top: 8px">
      Herramientas de control de contratación comercial
    </f7-block-header>
    <div class="oea-grid">
      <f7-link href="/dashboard/oea/control-cifras/" class="oea-card active" style="border-bottom: 4px solid #534AB7">
        <div class="card-icon" style="background: #EEEDFE">
          <f7-icon f7="graph_square" style="color: #534AB7; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Control de cifras</p>
        <p class="card-subtitle">Ficha mensual</p>
      </f7-link>
      <f7-link href="/dashboard/oea/resumen-anual/" class="oea-card active" style="border-bottom: 4px solid #185FA5">
        <div class="card-icon" style="background: #E6F1FB">
          <f7-icon f7="calendar" style="color: #185FA5; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Resumen anual</p>
        <p class="card-subtitle">Visión 12 meses</p>
      </f7-link>
      <f7-link href="/dashboard/oea/configuracion/" class="oea-card active" style="border-bottom: 4px solid #0F6E56" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
        <div class="card-icon" style="background: #E1F5EE">
          <f7-icon f7="gear_alt" style="color: #0F6E56; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Configuración</p>
        <p class="card-subtitle">Personas y objetivos</p>
      </f7-link>
      <f7-link href="/dashboard/oea/ejercicios/" class="oea-card active" style="border-bottom: 4px solid #BA7517">
        <div class="card-icon" style="background: #FAEEDA">
          <f7-icon f7="chart_bar_alt_fill" style="color: #BA7517; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Por ejercicios</p>
        <p class="card-subtitle">Histórico 2007-{{ new Date().getFullYear() }}</p>
      </f7-link>
      <f7-link href="/dashboard/oea/notificaciones/" class="oea-card active" style="border-bottom: 4px solid #D85A30" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
        <div class="card-icon" style="background: #FAECE7">
          <f7-icon f7="bell_fill" style="color: #D85A30; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Notificaciones</p>
        <p class="card-subtitle">Reglas y envíos</p>
      </f7-link>
    </div>
  </f7-page>
</template>
<style scoped>
.oea-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 16px;
  padding: 16px;
}
.oea-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.oea-card.active {
  cursor: pointer;
}
.oea-card.active:active {
  transform: scale(0.97);
}
.oea-card.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a2744;
  margin: 0;
}
.card-subtitle {
  font-size: 11px;
  margin: 2px 0 0;
  color: #7c8db0;
}
.card-badge {
  font-size: 10px;
  margin-top: 8px;
  color: #999;
}

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; }
</style>
<script>
import SelloDatos from '../../components/SelloDatos.vue';
export default {
  components: { SelloDatos }
};
</script>
